// extracted by mini-css-extract-plugin
module.exports = {"avisUHDHDR":"avisUHDHDR_avisUHDHDR__n2qek","webview":"avisUHDHDR_webview__O4KJZ"};